'use client';

import { RadioTile } from '@bytel/trilogy-react';

import { HomepackProduct, HomepackProductOptions, StaticPackProduct } from '@app-types/home-pack';

import { VariantState } from '@trilogy-ds/react/lib/objects/facets/Variant';

interface ProductSizeContainerProps {
    product: HomepackProduct;
    detail: HomepackProductOptions;
    selectedProduct?: StaticPackProduct;
    onSelectedProduct: (mainProduct: HomepackProduct, details: HomepackProductOptions) => void;
}

export function ProductSizeContainer({
    product,
    detail,
    selectedProduct,
    onSelectedProduct,
}: Readonly<ProductSizeContainerProps>) {
    const isActive = selectedProduct?.mainProduct?.id === product.id && selectedProduct?.details?.cm === detail.cm;

    return (
        <RadioTile
            className='button-tile'
            checked={isActive}
            onChange={() => {
                if (product) {
                    onSelectedProduct(product, detail);
                }
            }}
            label={`${detail.pouces}"`}
            description={`${detail.cm} cm`}
            sticker={detail?.promo ? 'Bon plan' : undefined}
            stickerVariant={isActive ? VariantState.MAIN : VariantState.INFO}
        />
    );
}
